$(document).on('keydown', '.js-mask', (event) => {
  if (event.which === 32) return false
})

$(document).on('maskInit', () => {
  $('.js-mask').each((_, element) => {
    let maskPlaceholder = '?+7 (999) 999-99-99'
    const currentTarget = $(element)
    if (currentTarget.data('mask')) {
      maskPlaceholder = currentTarget.data('mask')
    }
    currentTarget.mask(maskPlaceholder)
  })

  $('.js-validate input, .js-validate textarea').on('blur change', (event) => {
    const currentTarget = $(event.currentTarget)
    setTimeout(() => {
      currentTarget.valid()
    }, 100)
  })
})

$(document).trigger('maskInit')
